/**
 * ActualSpentPage - Standalone page for Time Tracker
 * 
 * This is a top-level route (/actual-spent) that displays all timesheet entries
 * across all projects the user has access to.
 * 
 * Features:
 * - Shows all entries with Job # column to identify project
 * - Full ActualSpentLog functionality
 */

import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import ActualSpentLog from './ActualSpentLog';
import Toast from '../Layout/Toast';
import { useToast } from '../../hooks/useToast';

const ActualSpentPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { toast, hideToast } = useToast();
  
  // Check if user came from a project (for back navigation)
  const fromProject = location.state?.fromProject;
  const fromProjectId = location.state?.projectId;
  
  // Handle back navigation
  const handleBackToProject = () => {
    if (fromProjectId) {
      navigate(`/project/${fromProjectId}`);
    } else {
      navigate(-1);
    }
  };
  
  return (
    <div style={{ 
      minHeight: '100%',
      backgroundColor: '#f5f7fa'
    }}>
      {/* Header */}
      <div style={{
        backgroundColor: 'white',
        borderBottom: '1px solid #e9ecef',
        padding: '1rem 1.5rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '1rem',
        flexWrap: 'wrap'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          {/* Back to Project button (only shown when navigated from project) */}
          {fromProject && (
            <button
              onClick={handleBackToProject}
              style={{
                padding: '0.5rem 1rem',
                backgroundColor: '#6c757d',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '0.9rem',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
              }}
            >
              ← Back
            </button>
          )}
          
          <h1 style={{ 
            margin: 0, 
            fontSize: '1.5rem', 
            fontWeight: '600',
            color: '#1a1a2e'
          }}>
            Time Tracker
          </h1>
        </div>
      </div>
      
      {/* Main Content - Always show ActualSpentLog with no projectId (all entries) */}
      <div style={{ padding: '0' }}>
        <ActualSpentLog 
          projectId={null}
          jobNumber={null}
          onFilterStateChange={() => {}}
        />
      </div>
      
      {/* Toast Notification */}
      <Toast
        message={toast.message}
        type={toast.type}
        isVisible={toast.show}
        onClose={hideToast}
        duration={5000}
      />
    </div>
  );
};

export default ActualSpentPage;
